import React from "react";
import { PROFILE } from "@/data/portfolio";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="bg-background"
    >
      <div className="max-w-3xl mx-auto px-6 pt-16 md:pt-24 pb-12 fade-in">
        <p
          data-testid="hero-status"
          className="font-mono text-xs text-quiet small-caps mb-6"
        >
          Mohammad Ashraf · Backend Software Engineer · {PROFILE.location}
        </p>

        <h1
          data-testid="hero-name"
          className="font-serif text-4xl md:text-5xl text-foreground leading-tight"
        >
          Hi, I'm <span className="italic">Mohammad Ashraf</span>.
        </h1>

        <p className="mt-6 text-lg md:text-xl text-foreground/85 leading-relaxed">
          I'm a backend software engineer based in Aligarh, India. For the last
          two years I've been at{" "}
          <a
            href="#experience"
            data-testid="hero-cta-work"
            className="link"
          >
            Telecrm
          </a>{" "}
          designing scalable distributed systems &mdash; event-driven pipelines,
          MongoDB indexes, background workers and the kind of unglamorous
          infrastructure that quietly handles 100k+ events a day.
        </p>

        <p className="mt-4 text-lg text-foreground/85 leading-relaxed">
          Most of what I build never makes it to a screenshot. It lives in
          queues, schedulers and consumer workers, and it's measured in p95s,
          not pixels.
        </p>

        <p className="mt-8 text-base text-quiet">
          <a
            href={PROFILE.resume}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-resume-download"
            className="link"
          >
            View résumé (PDF)
          </a>
          {" · "}
          <a href="#experience" className="link">read on ↓</a>
        </p>
      </div>
    </section>
  );
};
